export default [{
  path: '/stage/beautyCard',
  name: 'stage-beautyCard',
  redirect: '/stage/beautyCard/setMeal',
  title: '套餐办理/划扣',
  component: () => import('@/views/stage/template/beautyCard/index'),
  children: [{
    path: '/stage/beautyCard/setMeal',
    name: 'stage-setMeal',
    title: '套餐办理/划扣',
    component: () => import('@/views/stage/template/beautyCard/template/beautySetMeal')
  }, {
    path: '/stage/beautyCard/lookRecord',
    name: 'stage-lookRecord',
    title: '查看记录',
    component: () => import('@/views/stage/template/beautyCard/template/lookRecord')
  }]
}, {
  path: '/stage/recharge',
  name: 'stage-recharge',
  title: '购买/续费',
  component: () => import('@/views/stage/template/beautyCard/template/recharge')
}];
